function removePennyInitialMessageKeys() {
    const prefix = 'PennyInitialMessageSubmitted';
    Object.keys(sessionStorage).forEach((key)=>{
        if (key.startsWith(prefix)) sessionStorage.removeItem(key);
    });
}
export { removePennyInitialMessageKeys };
